import { AxiosInstance } from "../../axios/axiosInstance";
import { CompanyCamConfigData } from "../../components/PlatformIntegration/CompanyCam";
import { apiRoutes } from "../../utils/ApiRoutes";

const cleanFormDataFiles = (formData: any): any => {
  if (formData instanceof FormData) {
    const cleanFormData = new FormData();
    formData.forEach((value, key) => {
      if (value instanceof File) {
        // Replace all spaces with underscores to prevent API failure
        const cleanName = value.name.replace(/\s+/g, "_");
        cleanFormData.append(key, value, cleanName);
      } else {
        cleanFormData.append(key, value);
      }
    });
    return cleanFormData;
  }
  return formData;
};

export const uploadLogoApi = async (file: any) => {
  const processedFile = cleanFormDataFiles(file);
  const response = await AxiosInstance.post(
    apiRoutes?.uploadLogo,
    processedFile,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response;
};

export const uploadassetsApi = async (file: any) => {
  const processedFile = cleanFormDataFiles(file);
  const response = await AxiosInstance.post(
    apiRoutes?.uploadmomentassets,
    processedFile,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response;
};

export const editMapCheckInFormApi = async (payload: any) => {
  const response = await AxiosInstance.post(
    apiRoutes?.editMapChekInForm,
    payload,
  );
  return response;
};

export const getIntegrationApi = async (business_id: string) => {
  const response = await AxiosInstance.post(apiRoutes?.getIntegration, {
    business_id,
  });
  return response;
};

export const addIntegrationApi = async (payload: {
  checkin_id: string;
  type: string;
}) => {
  const response = await AxiosInstance.post(apiRoutes?.addIntegration, payload);
  return response;
};

export const enhanceDescriptionApi = async (payload: {
  business_id: string;
  description: string;
  categories?: string[];
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.enhanceDescription,
    payload,
  );
  return response;
};

export const generatePostDescriptionApi = async (payload: {
  media: string;
  business_id: string;
  description?: string;
  category_ids?: string[];
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.generatePostDescription,
    payload,
  );
  return response;
};

export const cancelCheckinSubscriptionApi = async (payload: any) => {
  const response = await AxiosInstance.post(
    apiRoutes?.addonCancelCheckinSubscription,
    payload,
  );
  return response;
};

export const restoreCheckinSubscriptionApi = async (payload: any) => {
  const response = await AxiosInstance.post(
    apiRoutes?.addonRestoreCheckinSubscription,
    payload,
  );
  return response;
};

export const getGMBreviewsApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.getgmbreviews, payload);
  return response;
};

export const facebookExchangeTokenApi = async (payload: {
  bridge_token: string;
  code: string;
  workspaceId: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.facebookExchangeToken,
    payload,
  );
  return response;
};

export const instagramExchangeTokenApi = async (payload: {
  bridge_token: string;
  code: string;
  workspaceId: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.instagramExchangeToken,
    payload,
  );
  return response;
};

export const youtubeExchangeTokenApi = async (payload: {
  bridge_token: string;
  workspaceId: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.youtubeExchangeToken,
    payload,
  );
  return response;
};

export const tiktokExchangeTokenApi = async (payload: {
  bridge_token: string;
  workspaceId: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.tiktokExchangeToken,
    payload,
  );
  return response;
};

export const instagramPortfolioExchangeTokenApi = async (payload: {
  bridge_token: string;
  code: string;
  workspaceId: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.instagramPortfolioExchangeToken,
    payload,
  );
  return response;
};

export const updateWidgetPreferenceIntegrationApi = async (payload: {
  integration_id: string;
  widget_preference: string;
  selected_widgets: string[];
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.updateWidgetPreferenceIntegration,
    payload,
  );
  return response;
};

export const listAudioApi = async () => {
  const response = await AxiosInstance.get(apiRoutes?.listAudio);
  return response;
};

export const jobberExchangeTokenApi = async (payload: {
  code?: string;
  businessId?: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.exchangeJobberToken,
    payload,
  );
  return response;
};

export const companyCamExchangeTokenApi = async (payload: {
  code?: string;
  businessId?: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.exchangeCompanyCamToken,
    payload,
  );
  return response;
};

export const companyCamConfigApi = async (payload: CompanyCamConfigData) => {
  const response = await AxiosInstance.post(
    apiRoutes?.companyCamConfigs,
    payload,
  );
  return response;
};

export type JobberConfigData = {
  businessId: string;
  auto_generate_description: boolean;
  auto_sync_description: boolean;
  auto_publish: boolean;
  primary_category: string | null;
  default_description_template: string;
};

export const jobberConfigApi = async (payload: JobberConfigData) => {
  const response = await AxiosInstance.post(apiRoutes?.jobberConfigs, payload);
  return response;
};

export const bulkScheduleCheckinsApi = async (payload: any) => {
  const response = await AxiosInstance.post(
    apiRoutes?.bulkScheduleCheckins,
    payload,
  );
  return response;
};

export const getReviewsApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.getReviews, payload);
  return response;
};

export const refreshReviewsApi = async (payload: { business_id: string }) => {
  const response = await AxiosInstance.post(apiRoutes?.refreshReviews, payload);
  return response;
};

export const getReviewSummaryApi = async (payload: { business_id: string }) => {
  const response = await AxiosInstance.post(
    apiRoutes?.getReviewSummary,
    payload,
  );
  return response;
};

export const replyReviewApi = async (payload: {
  business_id: string;
  review_name: string;
  reply_comment: string;
}) => {
  const response = await AxiosInstance.post(apiRoutes?.replyReview, payload);
  return response;
};

export const confirmDraftReviewApi = async (payload: {
  business_id: string;
  review_id: string;
}) => {
  const response = await AxiosInstance.post(apiRoutes?.confirmDraft, payload);
  return response;
};

export const generateReviewRequestApi = async (payload: {
  business_id: string;
  message: string;
  images?: string[];
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.generateReviewRequest,
    payload,
  );
  return response;
};

export const toggleAutomationApi = async (payload: {
  business_id: string;
  enabled: boolean;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.toggleAutomation,
    payload,
  );
  return response;
};

export const getReviewConfigApi = async (payload: { business_id: string }) => {
  const response = await AxiosInstance.post(
    apiRoutes?.getReviewConfig,
    payload,
  );
  return response;
};

export const updateReviewConfigApi = async (payload: {
  business_id: string;
  star_rating_actions: Record<string, { action: string; agent_id?: string }>;
  guardrails: {
    min_age_days_disabled: number;
    banned_words: string[];
  };
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.updateReviewConfig,
    payload,
  );
  return response;
};

export const listAgentsApi = async (payload?: { business_id?: string }) => {
  const response = await AxiosInstance.post(
    apiRoutes?.agentsList,
    payload || {},
  );
  return response;
};

export const createAgentApi = async (payload: {
  business_id?: string;
  name: string;
  instructions: string;
  tones: string[];
  language: string;
}) => {
  const response = await AxiosInstance.post(apiRoutes?.agentsCreate, payload);
  return response;
};

export const editAgentApi = async (payload: {
  agent_id: string;
  business_id?: string;
  name: string;
  instructions: string;
  tones: string[];
  language: string;
}) => {
  const response = await AxiosInstance.post(apiRoutes?.agentsEdit, payload);
  return response;
};

export const deleteAgentApi = async (payload: {
  agent_id: string;
  business_id?: string;
}) => {
  const response = await AxiosInstance.post(apiRoutes?.agentsDelete, payload);
  return response;
};

export const generateQuickReplyApi = async (payload: {
  business_id: string;
  review_comment: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.generateQuickReply,
    payload,
  );
  return response;
};

export const checkinBusinessCustomerPortalApi = async (payload: {
  business_id: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.checkinBusinessCustomerPortal,
    payload,
  );
  return response;
};

export const checkinBusinessSetupPaymentMethodApi = async (payload: {
  business_id: string;
  billingDetailsCollectionConfiguration?: {
    name?: "always" | "auto" | "never";
    email?: "always" | "auto" | "never";
  };
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.checkinBusinessSetupPaymentMethod,
    payload,
  );
  return response;
};

export const checkinBusinessSubscriptionDetailsApi = async (payload: {
  business_id: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.checkinBusinessSubscriptionDetails,
    payload,
  );
  return response;
};

export const checkinBusinessInvoicesApi = async (payload: {
  business_id: string;
  page: number;
  limit: number;
  sort_by?: string;
  sort_order?: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.checkinBusinessInvoices,
    payload,
  );
  return response;
};

export const checkinBusinessTopupsApi = async (payload: {
  business_id: string;
  page: number;
  limit: number;
  sort_by?: string;
  sort_order?: string;
  charge_filter?: "auto" | "manual"; // server-side filter: omit = all
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.checkinBusinessTopups,
    payload,
  );
  return response;
};

export const retryPurchaseApi = async (payload: { transaction_id: string }) => {
  const response = await AxiosInstance.post(
    apiRoutes?.retryPurchase,
    payload,
  );
  return response;
};

export const getAutoChargeConfigApi = async (payload: { business_id: string }) => {
  const response = await AxiosInstance.post(
    apiRoutes?.autoChargeConfig,
    payload,
  );
  return response;
};

export const updateAutoChargeConfigApi = async (payload: {
  business_id: string;
  auto_charge_enabled: boolean;
  minimum_balance: number;
  target_balance: number;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.updateAutoChargeConfig,
    payload,
  );
  return response;
};

export const listCreditAlertsApi = async (payload: { business_id: string }) => {
  const response = await AxiosInstance.post(
    apiRoutes?.listCreditAlerts,
    payload,
  );
  return response;
};

export const addCreditAlertApi = async (payload: {
  business_id: string;
  threshold: number;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.addCreditAlert,
    payload,
  );
  return response;
};

export const editCreditAlertApi = async (payload: {
  alert_id: string;
  business_id: string;
  threshold: number;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.editCreditAlert,
    payload,
  );
  return response;
};

export const deleteCreditAlertApi = async (payload: {
  alert_id: string;
  business_id: string;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes?.deleteCreditAlert,
    payload,
  );
  return response;
};
